import { cn, createBEM } from "@/libs";
import { Button, Toast } from "antd-mobile";
import { Icon, IconName } from "../Icon";
import copy from 'copy-to-clipboard';
import { DialogLocal } from "@/components/Dialog";
import "./index.scss";
import { error } from "console";

type CopyIconProps = {
  text: string;
  icon?: IconName;
  className?: string;
  size?: string;
  isWalletAddress?: boolean;//是否是钱包地址的复制
};
const b = createBEM("i-copy-icon");
export const CopyIcon = (props: CopyIconProps) => {
  const handleCopy = (e: any) => {
    e.stopPropagation();
    
    try{
      if (document.execCommand('copy')) {
        let textArea = document.createElement("textarea");
        textArea.value = props.text;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = "absolute";
        textArea.style.opacity = '0';
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy')
        textArea.remove();
      }else{
        copy(props.text);
      }
    }catch(err){
      copy(props.text);
      console.log(err);
    }

    // if(props.isWalletAddress){
    //   DialogLocal({
    //     closeOnMaskClick: false,
    //     title: "安全提醒",
    //     content: "请不要将钱包地址提供给陌生人，以避免造成不必要的经济损失，如因此造成的后果和损失，将由您自行承担。",
    //   });
    // }
    return Toast.show(`已复制 ${props.text}`);
  };
  // TODO 图标太小无法形成足够的点击区域，使用Button组件，检查各个引用页面微调样式
  return (
    <Button
      fill="none"
      onClick={(e) => {handleCopy(e)}}
      className={cn(b(), props.className || "")}
      style={{ cursor: "pointer" }}
    >
      <Icon name={props.icon || "copy"} size={props.size || "16px"} />
    </Button>
  );
};
